import { alpha, styled, Switch } from '@mui/material';

export const BlueSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#3d91ff',
    '&:hover': {
      backgroundColor: alpha('#3d91ff', theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#3d91ff',
  },
}));
